import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import AddPlayerModal from './AddPlayerModal';
import { normalizeSearchText, matchesSearch } from '../../common/utils/normalize';
export default class PlayersPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "players", []);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "canManage", false);
    // Filter state
    _defineProperty(this, "filter", '');
    _defineProperty(this, "selectedTeam", '');
    _defineProperty(this, "statusFilter", 'active');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.selectedTeam = app.forum.attribute('nagusiMatchRatingsPrimaryTeamId') || '531';
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    this.loadPlayers();
  }
  loadPlayers() {
    this.loading = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/players"
    }).then(response => {
      this.players = app.store.pushPayload(response);
      this.loading = false;
      m.redraw();
    }).catch(e => {
      if (e.status === 404) {
        this.loading = false;
        this.players = [];
        m.redraw();
      }
    });
  }
  getUniqueTeams() {
    const teams = new Map();
    this.players.forEach(p => {
      const playerTeams = p.teams() || [];
      playerTeams.forEach(t => {
        if (!teams.has(t.id())) {
          teams.set(t.id(), t);
        }
      });
    });
    return Array.from(teams.values()).sort((a, b) => a.name().localeCompare(b.name()));
  }
  view() {
    const query = normalizeSearchText(this.filter);
    const filteredPlayers = this.players.filter(p => {
      const nameMatch = matchesSearch(p.name(), query);
      const aliases = (p.attribute('aliases') || '').split(/[;,]/);
      const aliasMatch = aliases.some(a => matchesSearch(a, query));
      if (query && !nameMatch && !aliasMatch) return false;
      let teamMatch = true;
      if (this.selectedTeam === 'ALL') {
        teamMatch = true;
      } else if (this.selectedTeam === 'NONE') {
        const playerTeams = p.teams() || [];
        teamMatch = playerTeams.length === 0;
      } else if (this.selectedTeam) {
        const playerTeamIds = (p.teams() || []).map(t => String(t.id()));
        teamMatch = playerTeamIds.includes(String(this.selectedTeam));
      }
      let statusMatch = true;
      const active = p.isActive !== undefined ? typeof p.isActive === 'function' ? p.isActive() : p.isActive : true;
      if (this.statusFilter === 'active') {
        statusMatch = active !== false;
      } else if (this.statusFilter === 'inactive') {
        statusMatch = active === false;
      } else if (this.statusFilter === 'all') {
        statusMatch = true;
      }
      return nameMatch && teamMatch && statusMatch;
    }).sort((a, b) => a.name().localeCompare(b.name()));
    return m("div", {
      className: "PlayersPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 40px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; gap: 15px; margin-bottom: 40px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.nav_back_taldezaina')), m(Link, {
      href: "/",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-home"
    }), app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.nav_back_home'))), m("div", {
      className: "PlayersPage-header",
      style: "display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px;"
    }, m("h2", {
      style: "font-size: 2.2em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players.title')), this.canManage && m(Button, {
      className: "Button Button--primary",
      onclick: () => app.modal.show(AddPlayerModal, {
        defaultTeamId: this.selectedTeam,
        onSave: () => this.loadPlayers()
      }),
      style: "font-weight: bold; border-radius: 8px; padding: 10px 20px; display: inline-flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-plus"
    }), app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.btn_add_player'))), m("div", {
      className: "PlayersPage-filters",
      style: "margin-bottom: 35px; display: flex; gap: 15px; align-items: center; flex-wrap: wrap;"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 10px; flex: 1; min-width: 250px;"
    }, m("i", {
      className: "fas fa-search",
      style: "color: var(--muted-color);"
    }), m("input", {
      className: "FormControl",
      placeholder: app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.search_placeholder'),
      value: this.filter,
      oninput: e => this.filter = e.target.value,
      style: "flex: 1; border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02);"
    })), m("div", {
      style: "display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: "fas fa-shield-alt",
      style: "color: var(--muted-color);"
    }), m("select", {
      className: "FormControl",
      value: this.selectedTeam,
      onchange: e => this.selectedTeam = e.target.value,
      style: "width: auto; min-width: 180px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02);"
    }, m("option", {
      value: "ALL"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.team_filter_all')), m("option", {
      value: "NONE"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.team_filter_none')), this.getUniqueTeams().map(team => m("option", {
      value: team.id()
    }, team.name())))), m("div", {
      style: "display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: "fas fa-user-slash",
      style: "color: var(--muted-color);"
    }), m("select", {
      className: "FormControl",
      value: this.statusFilter,
      onchange: e => this.statusFilter = e.target.value,
      style: "width: auto; min-width: 160px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02);"
    }, m("option", {
      value: "active"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.status_filter_active')), m("option", {
      value: "inactive"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.status_filter_inactive')), m("option", {
      value: "all"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.status_filter_all'))))), this.loading ? m(LoadingIndicator, null) : m("div", {
      className: "PlayersList-container",
      style: "background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 16px; padding: 20px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.15);"
    }, m("table", {
      className: "PlayersTable",
      style: "width: 100%; border-collapse: collapse;"
    }, m("thead", null, m("tr", {
      style: "border-bottom: 2px solid rgba(255,255,255,0.1); text-align: left;"
    }, m("th", {
      style: "padding: 15px 10px; width: 95px; color: var(--heading-color); font-weight: bold;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.column_photo')), m("th", {
      style: "padding: 15px 10px; color: var(--heading-color); font-weight: bold;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.column_name')), m("th", {
      style: "padding: 15px 10px; color: var(--heading-color); font-weight: bold;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.column_teams')), this.canManage && m("th", {
      style: "padding: 15px 10px; text-align: right; width: 150px; color: var(--heading-color); font-weight: bold;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.column_actions')))), m("tbody", null, filteredPlayers.map(p => {
      const playerTeams = p.teams() || [];
      return m("tr", {
        className: "PlayerItem",
        key: p.id(),
        style: "border-bottom: 1px solid rgba(255,255,255,0.06); transition: background 0.2s ease;"
      }, m("td", {
        style: "padding: 15px 10px; vertical-align: middle; text-align: left;"
      }, p.photoUrl() ? m("img", {
        src: p.photoUrl(),
        alt: p.name(),
        style: "height: 70px; width: 70px; border-radius: 50%; object-fit: cover; border: 2px solid rgba(255, 255, 255, 0.1); box-shadow: 0 4px 10px rgba(0,0,0,0.15);"
      }) : m("div", {
        style: "height: 70px; width: 70px; border-radius: 50%; background: rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: center; border: 2px solid rgba(255, 255, 255, 0.1);"
      }, m("i", {
        className: "fas fa-user",
        style: "font-size: 2.2rem; color: var(--muted-color);"
      }))), m("td", {
        style: "padding: 15px 10px; vertical-align: middle;"
      }, m("div", {
        style: "display: flex; flex-direction: column;"
      }, m("div", {
        style: "display: flex; align-items: center; gap: 8px; flex-wrap: wrap;"
      }, m("span", {
        style: "font-size: 1.15em; font-weight: bold; color: var(--heading-color);"
      }, p.name()), p.attribute('entityType') !== 'coach' && p.number() !== null && p.number() !== undefined && m("span", {
        style: "background: rgba(255, 255, 255, 0.08); color: var(--heading-color); border: 1px solid rgba(255, 255, 255, 0.15); border-radius: 4px; padding: 1px 6px; font-size: 0.8em; font-weight: bold;"
      }, "#", p.number()), p.attribute('entityType') !== 'coach' && p.position() && m("span", {
        style: "background: rgba(59, 130, 246, 0.15); color: #60a5fa; border: 1px solid rgba(59, 130, 246, 0.3); border-radius: 4px; padding: 1px 6px; font-size: 0.75em; font-weight: bold;"
      }, app.translator.trans("bizkaitarra-lineup.forum.players_mgmt.positions.".concat(p.position().toLowerCase()))), p.attribute('entityType') === 'coach' && m("span", {
        className: "Player-Role-Badge coach",
        style: "background: rgba(234, 179, 8, 0.2); color: #facc15; border: 1px solid rgba(234, 179, 8, 0.4); border-radius: 4px; padding: 2px 8px; font-size: 0.8em; font-weight: bold;"
      }, "Entrenador"), typeof p.isActive === 'function' && p.isActive() === false && m("span", {
        className: "Player-Role-Badge inactive",
        style: "background: rgba(239, 68, 68, 0.2); color: #f87171; border: 1px solid rgba(239, 68, 68, 0.4); border-radius: 4px; padding: 2px 8px; font-size: 0.8em; font-weight: bold;"
      }, "Inactivo"), !p.apiId() && m("span", {
        className: "Player-Role-Badge manual",
        style: "background: rgba(234, 179, 8, 0.15); color: #facc15; border: 1px solid rgba(234, 179, 8, 0.3); border-radius: 4px; padding: 2px 6px; font-size: 0.75em; font-weight: bold; display: inline-flex; align-items: center; gap: 4px;",
        title: "Jugador creado manualmente, sin vincular a proveedor de datos"
      }, m("i", {
        className: "fas fa-exclamation-circle",
        style: "font-size: 0.9em;"
      }), " ", app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.badge_manual'))), m("div", {
        style: "display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-top: 4px;"
      }, p.birthPlace() && m("span", {
        style: "font-size: 0.85em; color: var(--muted-color); display: inline-flex; align-items: center; gap: 4px;"
      }, m("i", {
        className: "fas fa-map-marker-alt",
        style: "font-size: 0.8em;"
      }), " ", p.birthPlace()), p.attribute('aliases') ? m("span", {
        style: "font-size: 0.85em; opacity: 0.6; color: var(--muted-color);"
      }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.alias_label'), ": ", p.attribute('aliases').split(',').join(', ')) : null))), m("td", {
        style: "padding: 15px 10px; vertical-align: middle;"
      }, m("div", {
        style: "display: flex; flex-wrap: wrap; gap: 6px; align-items: center;"
      }, playerTeams.map(team => m("span", {
        key: team.id(),
        style: "display: inline-flex; align-items: center; gap: 6px; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1); border-radius: 20px; padding: 4px 10px; font-size: 0.85em; font-weight: 600; color: var(--heading-color);"
      }, team.logoUrl() ? m("img", {
        src: team.logoUrl(),
        alt: team.name(),
        style: "height: 16px; width: 16px; object-fit: contain;"
      }) : m("i", {
        className: "fas fa-shield-alt",
        style: "font-size: 0.8em; color: var(--muted-color);"
      }), m("span", null, team.name()))), playerTeams.length === 0 && m("span", {
        style: "color: var(--muted-color); font-size: 0.85em; font-style: italic;"
      }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.no_teams_assigned')))), this.canManage && m("td", {
        style: "padding: 15px 10px; vertical-align: middle; text-align: right;"
      }, m(Link, {
        href: app.route('bizkaitarra-lineup.players.edit', {
          id: p.id()
        }),
        className: "Button Button--secondary",
        style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 6px 12px; border: 1px solid rgba(255,255,255,0.15);",
        title: app.translator.trans('bizkaitarra-lineup.forum.players.edit_title')
      }, m("i", {
        className: "fas fa-edit"
      }), app.translator.trans('bizkaitarra-lineup.forum.players.edit_title'))));
    }))), filteredPlayers.length === 0 && m("p", {
      style: "text-align: center; padding: 25px; color: var(--muted-color); font-style: italic; margin: 0;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.no_players')))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/PlayersPage', PlayersPage);